import { BlurredTeaser, BlurredTeaserRow } from "~/components/BlurredTeaser";

type Member = {
  node: {
    user: {
      id: string;
      firstName: string;
      name: string;
      profileImageUrl: string;
    };
  };
};

type UpdatesTeaserProps = {
  members: Member[];
  onJoin: () => void;
};

const FAKE_ACTIONS = [
  "joined the club",
  "RSVP'd to Sunday morning yoga",
  "started a new chat",
];

const FAKE_FALLBACKS: BlurredTeaserRow[] = [
  {
    key: "fallback-tessa",
    name: "Tessa L.",
    action: FAKE_ACTIONS[0],
    avatarUrl: "/images/fake-profiles/fake-profile-1.png",
  },
  {
    key: "fallback-daniel",
    name: "Daniel R.",
    action: FAKE_ACTIONS[1],
    avatarUrl: "/images/fake-profiles/fake-profile-3.png",
  },
  {
    key: "fallback-maya",
    name: "Maya P.",
    action: FAKE_ACTIONS[2],
    avatarUrl: "/images/fake-profiles/fake-profile-4.png",
  },
];

const ROW_COUNT = 3;

export function UpdatesTeaser({ members, onJoin }: UpdatesTeaserProps) {
  const rows: BlurredTeaserRow[] = Array.from({ length: ROW_COUNT }, (_, i) => {
    const member = members[i]?.node.user;
    if (!member) return FAKE_FALLBACKS[i];
    return {
      key: member.id,
      name: member.firstName,
      action: FAKE_ACTIONS[i % FAKE_ACTIONS.length],
      avatarUrl: member.profileImageUrl,
    };
  });

  return (
    <BlurredTeaser
      heading="Updates"
      rows={rows}
      overlayTitle="Everyone's talking"
      overlayDescription="Join the club to see what they're planning."
      ctaLabel="Join the club"
      onCtaClick={onJoin}
    />
  );
}
